import { dataHourglassSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHourglassSolid = /*#__PURE__*/createIcon(dataHourglassSolid)
export default IconHourglassSolid
